var _rect, _path, _ellipse, _ellipse2, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgToothPlus(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 81,
    viewBox: "0 0 80 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 80,
    height: 80,
    rx: 40,
    fill: "#E6E5FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.5363 48.667C41.078 48.7534 41.6829 62.5005 45.916 62.5C48.5957 62.4992 50.3219 59.0415 50.6673 50.1372C51.013 41.2322 56.8011 39.2434 54.901 28.8695C53.0001 18.4953 40.7328 24.6002 37.5362 24.6002C34.3391 24.6002 22.0715 18.4953 20.1713 28.8695C18.2706 39.2434 24.0583 41.2322 24.4048 50.1372C24.75 59.0415 26.477 62.4992 29.1561 62.5C33.389 62.5006 33.9942 48.7536 37.5363 48.667Z",
    fill: "white",
    stroke: "#8E8CEE",
    strokeWidth: 2
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 28.6624,
    cy: 31.9357,
    rx: 2.95783,
    ry: 2.95783,
    fill: "#8E8CEE"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 50.426,
    cy: 26.0745,
    rx: 7.87234,
    ry: 7.87234,
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50.0003 34.8334C54.6027 34.8334 58.3337 31.1025 58.3337 26.5001C58.3337 21.8977 54.6027 18.1667 50.0003 18.1667C45.398 18.1667 41.667 21.8977 41.667 26.5001C41.667 31.1025 45.398 34.8334 50.0003 34.8334Z",
    stroke: "#8E8CEE",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M50.0005 23.1667V29.8334",
    stroke: "#8E8CEE",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M46.667 26.5H53.3337",
    stroke: "#8E8CEE",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgToothPlus);
export default __webpack_public_path__ + "static/media/tooth-plus.822c7b8c38200ed209dbf8b9b5e8dd0f.svg";
export { ForwardRef as ReactComponent };